import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    OnDestroy,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { CategoriaDTO } from "app/main/apps/shared/interfaces/categoria.interface";
import { GrupoServicioSolicitadoDTO } from "app/main/apps/shared/interfaces/grupo-servicio-solicitado.interface";
import { CodigoServicioDTO } from "app/main/apps/shared/interfaces/grupo-servicio.interface";
import { ContratistaService } from "app/main/apps/shared/services/rest/contratista.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-dialog-especialidades",
    templateUrl: "./dialog-especialidades.component.html",
    styleUrls: ["./dialog-especialidades.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogEspecialidadesComponent implements OnInit, OnDestroy {
    grupos = new FormControl();
    listaGrupos: CategoriaDTO[] = [];
    private subscripciones: Subscription;
    constructor(
        public dialogRef: MatDialogRef<DialogEspecialidadesComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            categorias: CategoriaDTO[];
            rutContratista: number;
            gruposContratrista: CodigoServicioDTO[];
            gruposSolicitados:GrupoServicioSolicitadoDTO[]
        },
        private _contratistaSrvc: ContratistaService,
        private _notificacionSrvc: NotificacionesService
    ) {
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
        this.subscripciones.add(
            this._contratistaSrvc.contratistaChanged$.subscribe(
                (contratista) =>
                    (this.data.gruposContratrista = contratista.gruposServicio)
            )
        );
    }

    buscarGruposCategoria(event: MatSelectChange) {
        //console.log(event.value);
        this.listaGrupos = this.filtraGruposPorCategoria(event.value);
        //console.log(this.listaGrupos);
    }

    filtraGruposPorCategoria(idCategoria: number): any[] {
        let gruposListados =  this.data.categorias.filter(
            (categoria) => categoria.id === idCategoria
        )[0].grupos;

        //filtro los grupos que ya estan aprobados
        let gruposAprobados=this.data.gruposContratrista;
        for(var i=0; i<gruposListados.length;i++){
            gruposAprobados.forEach(a => {
              if (a.id == gruposListados[i]?.id){
                gruposListados.splice(i,1);
                i--;
              }
            })
          }
          
          
      
          //filtro que no pueda elegir nada que no tenga solicitado
          for(var i=0; i<gruposListados.length;i++){
            this.data.gruposSolicitados.forEach(a=>{
              if (a.id == gruposListados[i]?.id){
                gruposListados.splice(i,1);
                i--;
              }
            })
          }
          return gruposListados;
    }

    

    guardar() {
        const gruposNuevos = this.grupos.value.map((grupo) => grupo.id);
        const gruposAntiguos = this.data.gruposContratrista.map(
            (grupo) => grupo.id
        );
        //console.log(gruposNuevos);
        //console.log(gruposAntiguos);
        let gruposConcat = gruposAntiguos.concat(gruposNuevos);
        gruposConcat = [...new Set([...gruposAntiguos, ...gruposNuevos])];

        this.subscripciones.add(
            this._contratistaSrvc
                .actualizaGrupos(this.data.rutContratista, gruposConcat)
                .subscribe((resp) => {
                    this._notificacionSrvc.mostrarNotificacion(
                        "Especialidades actualizadas",
                        "success"
                    );
                    this.dialogRef.close();
                    this._contratistaSrvc.contratistasRefresh$.next(true);
                    this._contratistaSrvc.especialidadesChanged$.next(true);
                })
        );
    }
    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
